import React, { ReactElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReactComponent as InpatientNoDataIcon } from '../../../../assets/images/svg/InpatientNoData.svg';
import { TPA_BANNER_TEXT } from '../../../../shared/constants/commonConstants';
import { RootState } from '../../../../store';
import {
  selectedGlobalSearch,
  setIsPreAuthView,
  setPageIndex,
  setSelectedElapsedTimeRemarks,
  setShowSelectedTpaSecondaryFilters,
  setTpaDeskSecondaryFilter,
  setTpaGlobalSearchClicked,
  setTPANextStatus,
} from '../../../../store/actions/inPatientAction';
import { ApplicationDetailModel } from '../../../../store/models/applicationDetailModel';
import { PayerInitialState } from '../../../../store/models/payerListModel';
import { concatenateValues, displayViewText } from '../service/crmUtils';
const InpatientNoData = (): ReactElement => {
  const {
    lookUp: { payerAllClaimStatuses = [] },
  } = useSelector((state: RootState): any => state || {});
  const { allPayers } = useSelector(
    (state: RootState): PayerInitialState => state.payerList,
  );
  const appDetail: ApplicationDetailModel = useSelector((state: RootState): ApplicationDetailModel => state?.applicationDetail || {});
  const dispatch = useDispatch();
  const isNewTpaDeskEnabled = appDetail.getIsNewTpaDeskEnabled();
  const isPreAuthClaimViewEnabled = appDetail?.getIsPreAuthClaimViewEnabled();
  const { isPreAuthView, viewCounts, displayFilters, tpaNextStatus, tpaGlobalSearch, filters } = useSelector(
    (state: RootState): any => state?.selectedInPatientDetail || {},
  );
  const showAvailableMessages = (!isNewTpaDeskEnabled || tpaNextStatus !== TPA_BANNER_TEXT.DRAFT_PENDING);
  const handelNavigation = (): void => {
    dispatch(setPageIndex(1));
    dispatch(setIsPreAuthView(!isPreAuthView));
    dispatch(selectedGlobalSearch(''));
    if (isPreAuthClaimViewEnabled && isNewTpaDeskEnabled) {
      dispatch(setTpaDeskSecondaryFilter([]));
      delete filters.elapsedTime; // deleting the elapsed filter from the filters object onchange of primary filter
      dispatch(setSelectedElapsedTimeRemarks([]));
      dispatch(setTPANextStatus(''));
      dispatch(setShowSelectedTpaSecondaryFilters([]));
    }
    if (tpaGlobalSearch?.value) {
      dispatch(setTpaGlobalSearchClicked(true));
    }
  };

  return (
    <div className="inpatient-no-data-container">
      <InpatientNoDataIcon />
      <p>
        No Data Found{Object?.keys(displayFilters)?.length ? ' for' : ''}
        <span className="inpatient_searched_text_p"
             dangerouslySetInnerHTML={{ __html: `${concatenateValues(displayFilters, allPayers, payerAllClaimStatuses, tpaGlobalSearch)}`}}
      /> in { displayViewText(isPreAuthView)}.
      </p>
     {(showAvailableMessages) &&
     <span className="inpatient-no-data-span">
        <span>We have found </span>{' '}
        {isPreAuthView
          ? viewCounts?.claimViewClaimCount
          : viewCounts?.preAuthViewClaimCount}{' '}
        results in
        <span onClick={handelNavigation} className={'link_text'}>
          {displayViewText(!isPreAuthView)} (
          {!isPreAuthView
            ? viewCounts?.preAuthViewClaimCount
            : viewCounts?.claimViewClaimCount}
          )
        </span>
      </span>}
    </div>
  );
};
export default InpatientNoData;
